import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export interface QuizStatusResponse {
  isActive: boolean;
  timeRemaining: number; // u sekundama
  startTime?: string;
  endTime?: string;
  adminCode?: string;
  message?: string;
}

/**
 * Proverava da li je kviz aktivan i vraća preostalo vreme
 * @returns QuizStatusResponse objekat
 */
const checkQuizStatus = async (): Promise<QuizStatusResponse> => {
  try {
    const config: AxiosRequestConfig = {
      method: "GET",
      // Lokalno (development)
      // url: `http://localhost:6002/api/ultra/politehnika/quiz-status`,
      
      // Produkcija
      url: `https://politehnika-back.firebird.rs/api/ultra/politehnika/quiz-status`,
    };

    const response: AxiosResponse = await axios(config);
    
    console.log("🔍 Quiz status response:", response.data);
    
    // Backend vraća CommonResponse: { code, message, description, data: {...} }
    const statusData = response.data.data;
    
    return {
      isActive: statusData.isActive,
      timeRemaining: statusData.timeRemaining || 0,
      startTime: statusData.startTime,
      endTime: statusData.endTime,
      adminCode: statusData.adminCode,
      message: statusData.message || response.data.description,
    };
  } catch (error) {
    console.error("❌ Greška pri proveri statusa kviza:", error);
    return {
      isActive: false,
      timeRemaining: 0,
    };
  }
};

export default checkQuizStatus;
